import React from "react";

const RoleWrapper = ({ roles, requiredRole, children }) => {
  if (!roles.includes(requiredRole)) return null; 
  return <>{children}</>; 
};

export default RoleWrapper;
